import React from 'react';

// Toggle-chip selector per shared-docs/frontend-architecture.md + ux-requirements.md:
//   - role="group" + aria-label on container
//   - aria-pressed on each chip
// `options` is array of { value, label }. `value` is the current value (single-select)
// or array of values (multi-select when `multi` is true).
export default function ChipSelector({
  options,
  value,
  onChange,
  label,
  multi = false,
  className = '',
}) {
  const isSelected = (optValue) => (multi ? value?.includes(optValue) : value === optValue);

  const handleClick = (optValue) => {
    if (multi) {
      const next = value?.includes(optValue)
        ? value.filter((v) => v !== optValue)
        : [...(value || []), optValue];
      onChange(next);
    } else {
      onChange(optValue);
    }
  };

  return (
    <div
      role="group"
      aria-label={label}
      className={['flex flex-wrap gap-2', className].join(' ')}
    >
      {options.map((opt) => {
        const selected = isSelected(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            aria-pressed={selected}
            onClick={() => handleClick(opt.value)}
            className={[
              'px-3 py-1.5 rounded-full text-sm font-medium border transition-colors',
              selected
                ? 'bg-primary-600 text-white border-primary-600'
                : 'bg-white dark:bg-night-surface text-gray-700 dark:text-night-text border-gray-200 dark:border-night-card hover:border-gray-300 dark:hover:border-night-muted',
            ].join(' ')}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
